/**
 * @description 判断是否是线上环境
 * @returns boolean
 */
// eslint-disable-next-line no-useless-escape
const isProd = (): boolean => /[a-z]+(?!-beta\d)\.duitang\.com/.test(window.location.host);

export default isProd;
